export default [
    {
        type: "开胃菜",
        children: [

        ],
    },
    {
        type: "副菜",
        children: [

        ],
    },
    {
        type: "主菜",
        children: [

        ],
    },
    {
        type: "甜品",
        children: [

        ],
    },
]